import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Actions
import { CreateSavePartnerContact, getPartnerContact } from '../../../../actions/workProviderContact'
// import { loginAs } from '../../../../actions/auth'

// import styles
import './view.scss'

// Components
import Phone from '../../../../shared/components/Phone'
import NotificationCopy from '../../../../shared/components/NotificationCopy'

// Elements
import Row from '../../../../shared/elements/row'
import Col from '../../../../shared/elements/col'
import Panel from '../../../../shared/elements/panel'
import Text from '../../../../shared/elements/text'
import Switch from '../../../../shared/elements/switch'
import LabelWrapper from '../../../../shared/elements/labelWrapper'

// Utils
import { hasAccess } from '../../../../utils/auth'
import { translation } from '../../../../utils/helpers'

class View extends Component {

  constructor (props) {
    super(props)
    this.state = {
      type: 'create',
      contact: {
        UserId: null,
        UserName: '',
        Email: '',
        Phone: '',
        PhoneCode: this.props.phonecode,
        WorkProviderId: props.workproviderId,
        ChainId: props.chainId,
        Active: true,
        NotificationSettings: []
      }
    }
    this.onInputChange = this.onInputChange.bind(this)
    this.saveAddContact = this.saveAddContact.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.getPartnerContact(this.props)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.item.UserId !== nextProps.item.UserId) {
      this.getPartnerContact(nextProps)
    }
  }

  onChange (e) {
    e.persist()
    let value = e.target.value

    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }
    this.setState({
      type: 'edit',
      contact: {
        ...this.state.contact,
        [e.target.name]: value
      }
    }, () => {
      if (e.target.type === 'checkbox') {
        this.onBlur(e)
      }
    })
  }

  onBlur (e) {
    if (this.state.contact.UserId !== null && this.state.contact.UserId !== 0) {
      this.setState({ type: 'edit' }, () => {
        this.saveAddContact()
      })
    }
  }

  getPartnerContact (props) {
    if (props.item.UserId !== undefined && props.item.UserId !== null && props.item.UserId !== 0) {
      props.getPartnerContact(props.item.UserId).then((res) => {
        this.setState({
          type: 'edit',
          contact: res.data
        })
      }, () => {
        this.props.onError()
      })
    } else {
      this.resetCreate()
    }
  }

  resetCreate () {
    this.setState({
      type: 'create',
      contact: {
        UserId: null,
        Phone: '',
        PhoneCode: this.props.phonecode,
        Active: true,
        UserName: '',
        Email: '',
        WorkProviderId: this.props.workproviderId,
        ChainId: this.props.chainId
      }
    })
  }

  onInputChange (e) {
    let value = e.target.value
    let name = e.target.name
    if (name === 'PhoneNumber') {
      name = 'Phone'
      this.setState({
        contact: {
          ...this.state.contact,
          [name]: value
        }
      })
    } else {
      this.setState({
        contact: {
          ...this.state.contact,
          PhoneCode: {
            Id: Number(value.Id)
          }
        }
      }, () => { this.onBlur() })
    }
  }

  renderNotificationCopy () {
    if (this.state.contact.UserId === null) return null
    const saveNotifications = (notifications) => {
      this.setState({
        contact: {
          ...this.state.contact,
          NotificationSettings: notifications
        }
      }, () => this.saveAddContact())
    }

    return (
      <NotificationCopy user={this.state.contact} SaveNotifications={saveNotifications.bind(this)} SMS />
    )
  }

  renderContact () {
    let { contact } = this.state
    if (contact === null) return null
    let title = !hasAccess([6], this.props.auth.user.UserType) ? '346' : '64'
    return (
      <Panel title={translation(title)}>
        <Text name='Name' value={contact.Name || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('30')} />
        <Text name='UserName' value={contact.UserName || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('1')} />
        <Text name='Email' value={contact.Email || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('1052')} />
        <LabelWrapper labelText={translation('345')}>
          <Phone
            onChange={this.onInputChange}
            onBlur={this.onBlur}
            code={contact.PhoneCode}
            number={contact.Phone} />
        </LabelWrapper>
        <Switch name='Active' onChange={this.onChange} checked={contact.Active} labelText={translation('295')} />
      </Panel>
    )
  }

  saveAddContact () {
    this.props.CreateSavePartnerContact(this.state.contact).then((res) => {
      this.props.onSave(res.data, this.state.type)
      this.setState({
        contact: res.data
      })
    }, (err) => {
      // Toastr
      if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
        if (this.state.contact.Email !== '' && this.state.contact.UserName !== '') {
          let errors = err.response.data.Errors
          let errText = ''
          for (let i = 0; i < errors.length; i++) {
            let dictKey = errors[i].DictionaryKey
            errText += '<br/>' + translation(dictKey)
          }
          window.toastr.error(translation(errText), translation('216'))
        }
      } else {
        const errorMessage = (error) => {
          let messageText = ''
          if (error < 5) {
            messageText += translation('17950')
          }
          if (messageText !== '') messageText += ' '
          switch (error) {
            case 1:
              messageText += translation('16329')
              break
            case 2:
              messageText += translation('16336')
              break
            case 3:
              messageText += translation('16335')
              break
            case 4:
              messageText += translation('16338')
              break
            case 5:
              messageText += translation('16337')
              break
            default:
              break
          }
          messageText += '<br>'
          return messageText
        }
        let errors = err.response.data
        if (Array.isArray(errors)) {
          let message = errors.map(error => errorMessage(error))
          window.toastr.error(message, translation('216'))
        } else {
          window.toastr.error(translation('13463'), translation('216'))
        }
      }
    })
  }

  render () {
    if (!hasAccess([2, 6], this.props.auth.user.UserType)) return null
    return (
      <Row>
        <Col>
          {this.renderContact()}
        </Col>
        <Col>
          {this.renderNotificationCopy()}
        </Col>
      </Row>
    )
  }
}

View.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    phonecode: state.common.phonecode
  }
}

export default connect(mapStateToProps, {
  CreateSavePartnerContact,
  getPartnerContact
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/Partners/Contacts/View/index.js